import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { OpenRecordSchema } from "slotworks/integration/revolver/schema/close-record-schema";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SlotDefinition from "slotworks/model/slot-definition";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import settingsModel from "slotworks/model/settings/settings-model";
import Components from "slotworks/components/components";

class RecoveryRecordBuilderBase implements RecordBuilder {

    public filter(data: any): boolean {
        let openResponse: OpenRecordSchema;

        if (data && data.data) {
            openResponse = data.data as OpenRecordSchema;
        }

        const isOpen = openResponse && openResponse.OPEN !== undefined;
        const isRecovery = isOpen && !GameState.getCurrentGame().getCurrentRecord();
        const isLateFreespins = isOpen && GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        return isRecovery || isLateFreespins;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const openResponse: OpenRecordSchema = data.data as OpenRecordSchema;

        const isLateFreespins = GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        if (isLateFreespins) {
            const firstRecord = GameState.getCurrentGame().getFirstRecord();
            if (!(firstRecord instanceof FreespinRecord) && !firstRecord.beenPaid) {
                const preservedDummyWin = GameState.getCurrentGame().getFirstRecord().creditsWon;

                const dummySpinRecord = new FreespinRecord();
                GameState.getCurrentGame().records[0] = dummySpinRecord;
                this.populateDummyRecord(dummySpinRecord);
                dummySpinRecord.totalFreespins = openResponse.OPEN.state.total;
                dummySpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
                const recoveredFSWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
                dummySpinRecord.creditsWon = recoveredFSWin + preservedDummyWin;

                gameplay.totalCreditsWon += parseFloat(recoveredFSWin as any);
                gameplay.totalFreespinsCreditsWon += recoveredFSWin;
            }

            return [];
        }

        if (openResponse.USER) {
            gameplay.balance = openResponse.USER.balance;
        }

        RevolverModel.game = openResponse.OPEN.game;
        RevolverModel.bet = JSON.stringify(openResponse.OPEN.bet_state);

        const recoveryRecords: Record[] = [];

        if (openResponse.OPEN.game.indexOf("BASE") === -1) {
            gameplay.isRecovered = true;

            const isFreeSpin = RevolverModel.isFreespin(openResponse.OPEN.game);
            const dummySpinRecord = isFreeSpin ? new FreespinRecord() : new SpinRecord();
            this.populateDummyRecord(dummySpinRecord);

            recoveryRecords.push(dummySpinRecord);

            const betState = openResponse.OPEN.bet_state;
            const coinLevel = SlotDefinition.coinSizes[betState.coin_level - 1];
            BetModel.setDefaults(SlotDefinition.stakes[betState.bet_level - 1], betState.lines, coinLevel);
            Components.paytable.refreshBetOptions();
            settingsModel.betState = betState;
            this.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
        }

        return recoveryRecords;
    }

    protected recoverBonuses(gameplay: Gameplay, data: any, openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[]) {
        if (openResponse.OPEN.state.total_bonus_games_win_amount) {
            gameplay.recoveredFreeSpinTotalWin += parseFloat(openResponse.OPEN.state.total_bonus_games_win_amount as any);
        }

        if (RevolverModel.isFreespin(openResponse.OPEN.game)) {
            const freespinRecord = dummySpinRecord as FreespinRecord;

            // Recover Freespins
            freespinRecord.freespinsTriggered = true;
            freespinRecord.beenPaid = true;

            freespinRecord.totalFreespins = openResponse.OPEN.state.total;
            freespinRecord.remainingFreespins = openResponse.OPEN.state.remain - 1;
            freespinRecord.isFreespinsComplete = openResponse.OPEN.state.is_complete;
            freespinRecord.gameName = openResponse.OPEN.state.game;

            gameplay.recoveredTotalFreespins = openResponse.OPEN.state.total;

            if (openResponse.OPEN.state.total_win_cash && gameplay.recoveredFreeSpinTotalWin === 0) {
                gameplay.recoveredFreeSpinTotalWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
            }

            this.recoverStickies(openResponse, freespinRecord);
        }

        gameplay.totalCreditsWon += parseFloat(gameplay.recoveredFreeSpinTotalWin as any);
    }

    private recoverStickies(openResponse: OpenRecordSchema, dummySpinRecord: SpinRecord) {
        let symbolIndex = 0;
        dummySpinRecord.overlayGrid = [];
        const stickyList = openResponse.OPEN.state.stickedWildsList;
        for (let reel = 0; reel < SlotDefinition.matrixGrid.length; reel++) {
            dummySpinRecord.overlayGrid.push([]);
            for (let symbol = 0; symbol < SlotDefinition.matrixGrid[reel]; symbol++) {
                symbolIndex++;
                dummySpinRecord.overlayGrid[reel].push(null);
                if (stickyList && stickyList.length) {
                    if (stickyList.indexOf(symbolIndex) > -1) {
                        dummySpinRecord.overlayGrid[reel][symbol] = "SWIL";
                    }
                }
            }
        }
    }

    private populateDummyRecord(record: SpinRecord) {
        record.creditsWon = 0;
        record.reelset = [];
        record.grid = [];
        record.stops = [];
        record.results = [];
        record.freespinsWon = 0;
    }
}

export default RecoveryRecordBuilderBase;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/records/recovery-record-builder-base.ts